import { z } from 'zod';
export const DeleteUserRequestPathSchema = z.object({
    userId: z.string(),
});
export const DeleteUserRequestSchema = DeleteUserRequestPathSchema;
export const DeleteUserResponseSchema = z.void();
export const DeleteUserApiSchema = { params: DeleteUserRequestPathSchema };
